import { Autocomplete, Chip, Fade, Paper, Stack, TextField } from '@mui/material'
import { useStoreState } from 'pullstate'
import { useCallback, useEffect, useState } from 'react'
import InputSearch from '../../components/InputSearch.jsx'
import { AppStore } from '../../stores/AppStore.js'
import { getPeopleBuilderStatus } from '../../utils/getPeopleBuilderStatus.js'

const PeopleBuilderFilter = ({
    setCurrentUser, setBreadcrumbsPb, breadcrumbsPb, allSubPlayers, component,
    openFilter, setFilteredPeopleBuilder, filteredPeopleBuilder,
    currentUser, setStatusToFilter, statusToFilter, playerNameToFilter, setPlayerNameToFilter,
    yearToFilter, setYearToFilter
}) => {
    const { peopleBuilders, goals, employees } = useStoreState(AppStore)
    const [qtyRowByYear, setQtyRowByYear] = useState(0)
    const [status, setStatus] = useState([])
    const [listName, setListName] = useState([])
    const [years, setYears] = useState([])
    const userLogged = useStoreState(AppStore, s => s.user)
    const statusOptions = [
        { label: 'No Goals' },
        { label: 'Draft Goal' },
        { label: 'Ready for Approval' },
        { label: 'Needs Revision' },
        { label: 'Active' },
        { label: 'Completed' }
    ]

    const handleFilter = useCallback(() => {
        let filtered = []
        let userStatus = new Set()
        let userCheckinStatus = []
        if (!peopleBuilders?.length || !goals?.length) return;

        filtered = peopleBuilders.filter(pb => {
            let goalsFiltered = goals.filter(goal => goal.people_builder_id === pb.id)
            let pbStatus = getPeopleBuilderStatus(goalsFiltered)
            goalsFiltered.forEach(goal => {
                userStatus.add(goal.goal_status);
                userCheckinStatus.push(goal.checkin_status);
            });
            let byName = !playerNameToFilter || (pb.player.full_name || '').toLowerCase().includes((playerNameToFilter || '').toLowerCase())
            let byYear = pb?.year == yearToFilter || yearToFilter === ''
            let bySuspended = !pb.player.suspended || pb.player.etro_team
            let byStatus = !goalsFiltered.length ?
                statusToFilter.includes('No Goals') || !statusToFilter.length :
                statusToFilter.includes(pbStatus.status) || !statusToFilter.length
            userStatus.clear()
            userCheckinStatus = []
            return byName && byYear && byStatus && bySuspended
        })

        if (location.pathname.includes('team')) {
            if (!yearToFilter) {
                filtered = filtered.filter(user => (user.player.coach === userLogged.full_name))
                setYearToFilter(filtered[0]?.year.toString())
            } else {
                filtered = filtered.filter(user => user.player.coach === userLogged.full_name)
            }
        }

        if (location.pathname.includes('company')) {
            if (!yearToFilter) {
                // filtered = filtered.filter(user => user.pb_settings.status !== 'previous')
                setYearToFilter(filtered[0]?.year.toString())
            }
        }

        filtered.sort((a, b) => a.player.full_name.localeCompare(b.player.full_name))

        setFilteredPeopleBuilder(filtered)
    }, [playerNameToFilter, yearToFilter, statusToFilter])

    const getTotalCountForChip = () => {
        if (!yearToFilter) return 0;
      
        if (component === 'department') {
          return allSubPlayers?.filter(p => p.year == yearToFilter).length || 0;
        }
      
        if (component === 'team') {
          return peopleBuilders.filter(
            pb =>
              pb.player.coach === userLogged.full_name &&
              pb.year == yearToFilter
          ).length;
        }
      
        // company
        return peopleBuilders.filter(
          pb => pb.year == yearToFilter
        ).length;
      };
      

      const getChip = () => {
        if (!playerNameToFilter && !yearToFilter && !statusToFilter.length) {
          return null;
        }
      
        const total = getTotalCountForChip();
      
        return (
          <Chip
            label={`Showing ${filteredPeopleBuilder.length} of ${total}`}
            variant="filled"
            color="info"
          />
        );
      };
      

    useEffect(() => {
        if (!employees?.length || !peopleBuilders?.length) return;
        if (component === 'department' && openFilter) {
            setListName(allSubPlayers.filter(player => player.year == yearToFilter).map(user => ({ label: user.player.full_name })).sort((a, b) => a.label.localeCompare(b.label)));
        } else if (component === 'department') {
            setListName(allSubPlayers.filter(user => user.player.coach === currentUser?.full_name)?.map(user => ({ label: user.player.full_name })).sort((a, b) => a.label.localeCompare(b.label)));
        } else if (component === 'team') {
            const teamPlayers = peopleBuilders
              .filter(pb =>
                pb.player.coach === userLogged.full_name &&
                (!yearToFilter || pb.year == yearToFilter)
              )
              .map(pb => ({ label: pb.player.full_name }))
              .sort((a, b) => a.label.localeCompare(b.label));
          
            setListName(teamPlayers);
          
          } else {
            // company view: all employees
            const employeesFiltered = employees.filter(
              user => !user.suspended && user.etro_team
            );
          
            setListName(
              employeesFiltered
                .map(user => ({ label: user.full_name }))
                .sort((a, b) => a.label.localeCompare(b.label))
            );
          }
          
    }, [employees, component, peopleBuilders, allSubPlayers, filteredPeopleBuilder, currentUser, playerNameToFilter])

    useEffect(() => {
        if (!peopleBuilders?.length) return;
        const years = []
        const getYears = []
        // const pbFiltered = peopleBuilders.filter(user => user.pb_settings.status !== 'previous')
        peopleBuilders.map((user, index) => {
            if (!years.includes(user.year.toString())) {
                getYears.push({ label: user.year.toString(), id: index })
            }
            years.push(user.year.toString())
        })
        setYears(getYears)
    }, [peopleBuilders])

    useEffect(() => {
        if (component !== 'department') {
            handleFilter()
        }
        setQtyRowByYear(peopleBuilders?.filter(user => user.year.toString() === yearToFilter).length || 0)
    }, [playerNameToFilter, yearToFilter, statusToFilter, currentUser, peopleBuilders, breadcrumbsPb, component])

    return (
        <>
            <Fade in={openFilter} timeout={500}>
                <Paper elevation={2} sx={{  p: 2, mb:1, borderRadius: 0 }}>
                    <Stack direction='row' gap={2} alignItems='center'>
                        <InputSearch
                            sizeProp={300}
                            list={listName}
                            value={playerNameToFilter}
                            onChange={(e, name) => {
                                name ? setPlayerNameToFilter(name?.label) : setPlayerNameToFilter('')
                            }}
                            label='Player'
                        />
                        <InputSearch
                            sizeProp={200}
                            list={years}
                            value={years.find(y => y.label === yearToFilter) || null}
                            onChange={(e, value) => {
                                value ? setYearToFilter(value?.label) : setYearToFilter('')
                            }}
                            label='Year'
                        />
                        <Autocomplete
                            multiple
                            id="tags-standard"
                            options={statusOptions}
                            onChange={(e, value) => {
                                setStatus(value)
                                value ? setStatusToFilter(value.map(status => status.label)) : setStatusToFilter([])
                            }}
                            sx={{ width: 600 }}
                            size='small'
                            value={statusOptions.filter(option =>
                                statusToFilter.includes(option.label)
                              )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Status"
                                />
                            )}
                        />
                        {getChip()}
                    </Stack>
                </Paper>
            </Fade>

        </>
    )
}

export default PeopleBuilderFilter